/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ISHONCH Platform API
 * Login: POST /api/v1/auth/otp → code (dev: in the app log) → POST /api/v1/auth/otp/verify → paste response_data.as_access_token into Authorize. Every response is the company envelope (ADR-0007).
 * OpenAPI spec version: v1
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type {
  CodeRequest,
  CodeSentResponse,
  RefreshRequest,
  TelegramLinkRequest,
  TelegramSignInRequest,
  TokenResponse,
  VerifyRequest,
} from "../iSHONCHPlatformAPI.schemas";

import { httpRequest } from "../../http";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getLogoutUrl = () => {
  return `/api/v1/auth/logout`;
};

export const logout = async (
  refreshRequest?: RefreshRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<null> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<null>(getLogoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(refreshRequest),
  });
};

export const getLogoutMutationKey = () => ["logout"] as const;

export const getLogoutMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    LogoutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  LogoutMutationVariables,
  TContext
> => {
  const mutationKey = getLogoutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    LogoutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return logout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>;
export type LogoutMutationBody = RefreshRequest | undefined;
export type LogoutMutationError = unknown;
export type LogoutMutationVariables = { data?: RefreshRequest };

export const useLogout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logout>>,
      TError,
      LogoutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  LogoutMutationVariables,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options), queryClient);
};
export const getRequestCodeUrl = () => {
  return `/api/v1/auth/otp`;
};

export const requestCode = async (
  codeRequest: CodeRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<CodeSentResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<CodeSentResponse>(getRequestCodeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(codeRequest),
  });
};

export const getRequestCodeMutationKey = () => ["requestCode"] as const;

export const getRequestCodeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestCode>>,
    TError,
    RequestCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestCode>>,
  TError,
  RequestCodeMutationVariables,
  TContext
> => {
  const mutationKey = getRequestCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestCode>>,
    RequestCodeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return requestCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestCodeMutationResult = NonNullable<Awaited<ReturnType<typeof requestCode>>>;
export type RequestCodeMutationBody = CodeRequest;
export type RequestCodeMutationError = unknown;
export type RequestCodeMutationVariables = { data: CodeRequest };

export const useRequestCode = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestCode>>,
      TError,
      RequestCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof requestCode>>,
  TError,
  RequestCodeMutationVariables,
  TContext
> => {
  return useMutation(getRequestCodeMutationOptions(options), queryClient);
};
export const getVerifyCodeUrl = () => {
  return `/api/v1/auth/otp/verify`;
};

export const verifyCode = async (
  verifyRequest: VerifyRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<TokenResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<TokenResponse>(getVerifyCodeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyRequest),
  });
};

export const getVerifyCodeMutationKey = () => ["verifyCode"] as const;

export const getVerifyCodeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyCode>>,
    TError,
    VerifyCodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyCode>>,
  TError,
  VerifyCodeMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyCodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyCode>>,
    VerifyCodeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyCodeMutationResult = NonNullable<Awaited<ReturnType<typeof verifyCode>>>;
export type VerifyCodeMutationBody = VerifyRequest;
export type VerifyCodeMutationError = unknown;
export type VerifyCodeMutationVariables = { data: VerifyRequest };

export const useVerifyCode = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyCode>>,
      TError,
      VerifyCodeMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyCode>>,
  TError,
  VerifyCodeMutationVariables,
  TContext
> => {
  return useMutation(getVerifyCodeMutationOptions(options), queryClient);
};
export const getRefreshUrl = () => {
  return `/api/v1/auth/refresh`;
};

export const refresh = async (
  refreshRequest?: RefreshRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<TokenResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<TokenResponse>(getRefreshUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(refreshRequest),
  });
};

export const getRefreshMutationKey = () => ["refresh"] as const;

export const getRefreshMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refresh>>,
    TError,
    RefreshMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refresh>>,
  TError,
  RefreshMutationVariables,
  TContext
> => {
  const mutationKey = getRefreshMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refresh>>,
    RefreshMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return refresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshMutationResult = NonNullable<Awaited<ReturnType<typeof refresh>>>;
export type RefreshMutationBody = RefreshRequest | undefined;
export type RefreshMutationError = unknown;
export type RefreshMutationVariables = { data?: RefreshRequest };

export const useRefresh = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refresh>>,
      TError,
      RefreshMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refresh>>,
  TError,
  RefreshMutationVariables,
  TContext
> => {
  return useMutation(getRefreshMutationOptions(options), queryClient);
};
export const getSignInWithTelegramUrl = () => {
  return `/api/v1/auth/telegram`;
};

export const signInWithTelegram = async (
  telegramSignInRequest: TelegramSignInRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<TokenResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<TokenResponse>(getSignInWithTelegramUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(telegramSignInRequest),
  });
};

export const getSignInWithTelegramMutationKey = () => ["signInWithTelegram"] as const;

export const getSignInWithTelegramMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInWithTelegram>>,
    TError,
    SignInWithTelegramMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signInWithTelegram>>,
  TError,
  SignInWithTelegramMutationVariables,
  TContext
> => {
  const mutationKey = getSignInWithTelegramMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signInWithTelegram>>,
    SignInWithTelegramMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return signInWithTelegram(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInWithTelegramMutationResult = NonNullable<
  Awaited<ReturnType<typeof signInWithTelegram>>
>;
export type SignInWithTelegramMutationBody = TelegramSignInRequest;
export type SignInWithTelegramMutationError = unknown;
export type SignInWithTelegramMutationVariables = { data: TelegramSignInRequest };

export const useSignInWithTelegram = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof signInWithTelegram>>,
      TError,
      SignInWithTelegramMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof signInWithTelegram>>,
  TError,
  SignInWithTelegramMutationVariables,
  TContext
> => {
  return useMutation(getSignInWithTelegramMutationOptions(options), queryClient);
};
export const getLinkTelegramUrl = () => {
  return `/api/v1/auth/telegram/link`;
};

export const linkTelegram = async (
  telegramLinkRequest: TelegramLinkRequest,
  options?: Parameters<typeof httpRequest>[1],
): Promise<null> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return httpRequest<null>(getLinkTelegramUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(telegramLinkRequest),
  });
};

export const getLinkTelegramMutationKey = () => ["linkTelegram"] as const;

export const getLinkTelegramMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof linkTelegram>>,
    TError,
    LinkTelegramMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof linkTelegram>>,
  TError,
  LinkTelegramMutationVariables,
  TContext
> => {
  const mutationKey = getLinkTelegramMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof linkTelegram>>,
    LinkTelegramMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return linkTelegram(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LinkTelegramMutationResult = NonNullable<Awaited<ReturnType<typeof linkTelegram>>>;
export type LinkTelegramMutationBody = TelegramLinkRequest;
export type LinkTelegramMutationError = unknown;
export type LinkTelegramMutationVariables = { data: TelegramLinkRequest };

export const useLinkTelegram = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof linkTelegram>>,
      TError,
      LinkTelegramMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof linkTelegram>>,
  TError,
  LinkTelegramMutationVariables,
  TContext
> => {
  return useMutation(getLinkTelegramMutationOptions(options), queryClient);
};
